import { render, staticRenderFns } from "./ObstacleInfo.vue?vue&type=template&id=94976850&scoped=true"
import script from "./ObstacleInfo.vue?vue&type=script&lang=js"
export * from "./ObstacleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94976850",
  null
  
)

export default component.exports